import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import ru from "date-fns/locale/ru";
import SalaryTable from "./Salary/SalaryTable";
import SalaryDetail from "./Salary/SalaryDetail/SalaryDetail";
import { getAllGroups } from "../../api/api";
import { calculateWorkingSalary } from "../../api/timesheetApi";
import { getMockSalaryData } from "./Salary/mockData";
import "./FinancialReport.css";

registerLocale("ru", ru);
setDefaultLocale("ru");

function Salary() {
  const [selectedMonth, setSelectedMonth] = useState(new Date());
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [departments, setDepartments] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  // Загрузка данных отделов с информацией о зарплатах
  useEffect(() => {
    const loadDepartments = async () => {
      setIsLoading(true);
      setError(null);

      try {
        const year = selectedMonth.getFullYear();
        const month = selectedMonth.getMonth() + 1;

        // Получаем список всех групп/отделов
        const allGroups = await getAllGroups();
        const activeGroups = allGroups.filter((group) => group.is_active);

        // Для каждого отдела получаем данные о зарплатах
        const departmentsWithData = await Promise.all(
          activeGroups.map(async (group) => {
            try {
              // Вызываем API для получения данных о зарплатах отдела
              const salaryData = await calculateWorkingSalary({
                group_id: group.id,
                year,
                month,
              });

              // Если есть данные о зарплатах, значит отдел имеет данные
              const hasData =
                salaryData && salaryData.items && salaryData.items.length > 0;

              return {
                id: group.id,
                name: group.name,
                initiator: null, // TODO: Получить из API согласований
                approvers: [], // TODO: Получить из API согласований
                submissionDate: null, // TODO: Получить из API согласований
                hasData, // Флаг наличия данных
              };
            } catch (err) {
              console.error(
                `Ошибка при загрузке данных для отдела ${group.name}:`,
                err,
              );
              // В случае ошибки все равно добавляем отдел, но без данных
              return {
                id: group.id,
                name: group.name,
                initiator: null,
                approvers: [],
                submissionDate: null,
                hasData: false,
              };
            }
          }),
        );

        // Фильтруем только отделы с данными или используем все (в зависимости от требований)
        // Пока показываем все отделы
        setDepartments(departmentsWithData);
      } catch (err) {
        console.error("Ошибка при загрузке отделов:", err);
        setError(err.message || "Ошибка при загрузке данных");
        // В случае ошибки используем моковые данные
        const mockData = getMockSalaryData(selectedMonth);
        setDepartments(mockData);
      } finally {
        setIsLoading(false);
      }
    };

    loadDepartments();
  }, [selectedMonth]);

  const handleDepartmentClick = (department) => {
    setSelectedDepartment(department);
  };

  const handleBack = () => {
    setSelectedDepartment(null);
  };

  // Если выбран отдел, показываем детальную страницу
  if (selectedDepartment) {
    return (
      <SalaryDetail
        department={selectedDepartment}
        onBack={handleBack}
        initialMonth={selectedMonth}
      />
    );
  }

  // Иначе показываем список отделов
  return (
    <div className="financial-report">
      <div style={{ padding: "20px" }}>
        <h2>Заработная плата</h2>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "20px",
            marginBottom: "20px",
          }}
        >
          <label>Месяц:</label>
          <div style={{ width: "200px" }}>
            <DatePicker
              selected={selectedMonth}
              onChange={(date) => setSelectedMonth(date)}
              dateFormat="MM.yyyy"
              showMonthYearPicker
              locale="ru"
              className="timesheet-datepicker"
              calendarClassName="custom-calendar month-year-calendar"
            />
          </div>
        </div>
        {isLoading && (
          <div style={{ padding: "20px", textAlign: "center" }}>
            <p>Загрузка данных...</p>
          </div>
        )}
        {error && !isLoading && (
          <div style={{ padding: "20px", color: "red", textAlign: "center" }}>
            <p>Ошибка: {error}</p>
          </div>
        )}
        {!isLoading && (
          <SalaryTable
            selectedMonth={selectedMonth}
            departments={departments}
            onDepartmentClick={handleDepartmentClick}
          />
        )}
      </div>
    </div>
  );
}

export default Salary;
